import React from 'react';
import { users } from 'types';
import DialogConfirm from 'components/dialog/dialog-confirm';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useUserPinReset from '../hooks/use-user-pin-reset';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { CellButtonContentStyled } from '../index.styled';

const DialogPinReset = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onPinReset] = useUserPinReset(asyncStatesHandlers);

    return (
        <DialogConfirm<users.TUsers>
            isDialogOpen={!!data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={<>Confirm user PIN reset</>}
            labels={{
                onOk: (
                    <CellButtonContentStyled>
                        <VpnKeyIcon /> Reset PIN
                    </CellButtonContentStyled>
                ),
            }}
            onOk={async () => {
                if (!data || !data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onPinReset({ id: data.id });
                } catch (e) {}
            }}
        />
    );
};

export default DialogPinReset;
